import {DoraProperty} from '../../../Decorators/Decorator';

export class LabelLink {
    @DoraProperty
    language = '';

    @DoraProperty
    linkWithPlaceholder = '';

    // tslint:disable-next-line:variable-name
    private _link: string;

    private placeholders: Map<string, string> = new Map<string, string>();

    get link(): string {
        if (this._link === undefined) {
            this._link = this.linkWithPlaceholder;
        }
        return this._link;
    }

    public setPlaceholder(name: string, value: string): void {
        this.placeholders.set(name, value);
        this.rebuildLink();
    }
    private rebuildLink(): void {
        this._link = this.linkWithPlaceholder;

        // replace all placeholders
        this.placeholders.forEach((value: string, key: string) => {
            this._link = this._link.replace(key, value);
        });
    }
}
